import { createAction } from 'redux-actions';
import { ACTIVATE_PERSONAL_LOAN } from 'actions/personal-loan-actions';
import { baseUrl, SOCKET_OPEN, SOCKET_MESSAGE, SOCKET_CLOSE, SOCKET_ERROR } from 'actions/ws-actions';
import { createSocketMiddleware } from './';

const CONTEXT = '/service-application-pl/ws/secure';

const socketUrl = () => `${baseUrl()}${CONTEXT}/api/v1/application`;
const socketPredicate = (action) => action.type === ACTIVATE_PERSONAL_LOAN;
const jwtOrNull = (store) => {
  const identity = store.getState().identityReducer || {};

  return (identity.jwt || '').replace('Bearer ', '') || null;
};

export const APP = 'APP';
const APP_SOCKET_MESSAGE = `${APP}_${SOCKET_MESSAGE}`;

const eventHandlers = {
  onopen: createAction(`${APP}_${SOCKET_OPEN}`),
  onclose: createAction(`${APP}_${SOCKET_CLOSE}`),
  onerror: createAction(`${APP}_${SOCKET_ERROR}`),
  onmessage: createAction(APP_SOCKET_MESSAGE, (e) => (typeof e === 'object' ? e.data : e)),
};

const createAppSocketMiddleware = (sendInterval = 5000, reconnect = true) =>
  createSocketMiddleware(socketUrl(), null, socketPredicate, undefined, eventHandlers, {
    sendInterval,
    reconnect,
    protocol: jwtOrNull,
  });

export default createAppSocketMiddleware;
